import { setFocus } from '@noriginmedia/norigin-spatial-navigation';
import { HEADER_HOME } from '@smart-tv/components/header/header-helpers';

export const setFocusToHomeAndScrollTop = () => {
  setFocus(HEADER_HOME);
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};
